/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-27 10:21:15
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-15 14:16:59
 * @FilePath: /src/app/payment/components/ProductList/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getNewCartList, getSubTotalPrice } from '@/api/cart';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { useStore } from '@/providers/app-store-provider';
import logger from '@/utils/client-logger';
import { formatPriceNumberWithSymbol } from '@/utils/price';
import { add } from '@/utils/tools';
import { useMediaQuery } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import ProductListMobile from './components/m';
import ProductListPC from './components/pc';

interface ProductListProps {
  redeemCartId: string;
  priceOrder: any;
  ref: React.RefObject<any>;
}

export default function ProductList(props: ProductListProps) {
  const { redeemCartId, priceOrder, ref } = props;

  // 在入口文件处进行公共数据的加工处理。
  const currency = useStore((state) => state.currency);
  const [showList, setShowList] = useState<boolean>(false);
  const [selectedList, setSelectedList] = useState<any[]>([]);
  const isMobile = useMediaQuery('(max-width: 768px)');

  const allQty = useMemo(() => {
    let qty = 0;
    if (redeemCartId) {
      qty = 1;
    } else {
      selectedList.forEach((productItem) => {
        qty += productItem.qty;
      });
    }
    return qty;
  }, [selectedList]);

  const getRedemList = async () => {
    try {
      const { data } = await getNewCartList({
        currency: currency.name,
        cart_ids: [redeemCartId],
        cart_type: 6,
      });

      const { data: subTotal } = await getSubTotalPrice({
        currency: currency.name,
        cart_ids: [Number(redeemCartId)],
      });

      let product_payable = 0;
      let product_rule_discounts_price = 0;

      if (subTotal?.tmp?.carts?.length > 0) {
        const findCarts = subTotal?.tmp?.carts?.find((item) => item.id === Number(redeemCartId));
        product_payable = Number(findCarts.product_payable);
        product_rule_discounts_price = Number(findCarts.product_rule_discounts_price);
      }

      setSelectedList(
        data.list[0].carts.map((item: any) => {
          // eslint-disable-next-line no-param-reassign
          item.product_info = item.product;
          item.product_payable = product_payable;
          item.product_rule_discounts_price = product_rule_discounts_price;
          return item;
        }),
      );
    } catch (error) {
      logger.log(error);
    }
  };

  useEffect(() => {
    if (redeemCartId) {
      !isMobile && setShowList(true);
      getRedemList();
      return;
    }
    setSelectedList(priceOrder?.carts || []);
  }, [redeemCartId, priceOrder]);

  const priceInfo = (item: any) => {
    try {
      const { product_payable, product_rule_discounts_price } = item;
      return getAddPrice(product_payable, product_rule_discounts_price);
    } catch (error) {
      logger.log(error);
      return '';
    }
  };

  const getAddPrice = (payable: number, discount: number) => {
    return add(payable, discount).toFixed(2);
  };

  // 处理每个产品项的价格和格式化显示
  const formattedList = selectedList.map((item) => ({
    ...item,
    formattedPrice: formatPriceNumberWithSymbol(priceInfo(item), currency),
    hasColor: !!(item.product_info.color_name || item.product_info.color),
  }));

  // 处理展示/隐藏列表的函数
  const toggleShowList = () => {
    setShowList(!showList);
  };

  return (
    <div className="bg-white rounded-[10px] md:rounded-[5px]  w-full md:py-[4px]  md:mb-[12px]">
      <WebOnly>
        <ProductListPC
          formattedList={formattedList}
          allQty={allQty}
          showList={showList}
          toggleShowList={toggleShowList}
          giftNum={priceOrder?.gift_num}
          redeemCartId={redeemCartId}
          ref={ref}
        />
      </WebOnly>
      <WapOnly>
        <ProductListMobile
          formattedList={formattedList}
          allQty={allQty}
          showList={showList}
          toggleShowList={toggleShowList}
          giftNum={priceOrder?.gift_num}
          redeemCartId={redeemCartId}
          ref={ref}
        />
      </WapOnly>
    </div>
  );
}
